(function ($) {
  const Init = (() => {
    let website = {},
      load = {},
      resize = {},
      resizeW = {},
      scroll = {},
      orientation = {},
      mod = {},
      anime = {},
      scrollOption = {},
      parallax = {},
      drawer = {},
      wp = {},
      slider = {},
      top = {},
      basic = {};

    website = {
      page: document.body.dataset.page,
      url: document.URL,
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      scrollY: window.pageYOffset,
      scrollCurrent: 0,
      breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576 },
      ua: navigator.userAgent.toLowerCase(),
      isDesktop: true,
      isMobile: false,
      isFirst: true,
      animationFrame: null,

      headTag: document.getElementById('js-header'),
      footTag: document.getElementById('js-footer'),
      // headTag       : $('#js-header'),
      // footTag       : $('#js-footer'),

      act: 'is-act',
      inact: 'is-inact',
      actView: 'is-view',
      actOpen: 'is-open',
      actClose: 'is-close',
      loaded: 'is-loaded',

      targetAnime: 'js-anime',
      actAnime: 'is-anime',
      shiftPoint: 0,
      shiftPc: 5,
      shiftSp: 10,
    };
    website.shiftPoint = website.breakpoint.tb;

    load = {
      functions: [],
      length: 0,
    };

    resize = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };
    resizeW = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    scroll = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    orientation = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    
    const WinLoad = {
    
      init() {
        window.addEventListener('load', function(e) {
          WinLoad.update();
        });
    
        console.log('!-- load init --!');
      },
    
      add(func) {
        load.functions.push(func);
        load.length = load.functions.length;
      },
    
      remove(func) {
        load.functions.splice(func, 1);
        load.length = load.functions.length;
      },
    
      update() {
        for ( let i = 0; i < load.length; i++ ) {
          let func = load.functions[i];
          func();
        }
      },
    
    }
    
    
    const WinResize = {
    
      init() {
        window.addEventListener('resize', function(e) {
          if ( !resize.isRunning ) {
            resize.isRunning = true;
    
            resize.animationFrame = window.requestAnimationFrame( WinResize.update );
    
            // if ( window.requestAnimationFrame ) {
            //   window.requestAnimationFrame(() => {
            //     WinResize.update();
            //   });
            // } else {
            //   setTimeout(() => {
            //     WinResize.update();
            //   }, 1000/resize.fps);
            // }
          }
        });
    
        console.log('!-- resize init --!');
      },
    
      add(func) {
        resize.functions.push(func);
        resize.length = resize.functions.length;
      },
    
      remove(func) {
        resize.functions.splice(func, 1);
        resize.length = resize.functions.length;
      },
    
      update() {
        website.winWidth  = window.innerWidth;
        website.winHeight = window.innerHeight;
        website.ua        = navigator.userAgent.toLowerCase();
    
        for ( let i = 0; i < resize.length; i++ ) {
          let func = resize.functions[i];
          func();
        }
    
        resize.isRunning = false;
      },
    
    }
    
    
    const WinResizeWidth = {
    
      init() {
        window.addEventListener('resize', function(e) {
          if ( website.winWidth != window.innerWidth && !resizeW.isRunning ) {
            resizeW.isRunning = true;
            resizeW.animationFrame = window.requestAnimationFrame( WinResizeWidth.update );
          }
        });
    
        console.log('!-- resizeW init --!');
      },
    
      add(func) {
        resizeW.functions.push(func);
        resizeW.length = resizeW.functions.length;
      },
    
      remove(func) {
        resizeW.functions.splice(func, 1);
        resizeW.length = resizeW.functions.length;
      },
    
      update() {
        for ( let i = 0; i < resizeW.length; i++ ) {
          let func = resizeW.functions[i];
          func();
        }
    
        resizeW.isRunning = false;
      },
    
    }
    
    
    const WinScroll = {
    
      init() {
        window.addEventListener('scroll', function(e) {
          if ( !scroll.isRunning ) {
            scroll.isRunning = true;
    
            scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
    
            // if ( window.requestAnimationFrame ) {
            //   window.requestAnimationFrame(() => {
            //     WinScroll.update();
            //   });
            // } else {
            //   setTimeout(() => {
            //     WinScroll.update();
            //   }, 1000/scroll.fps);
            // }
          }
        });
    
        console.log('!-- scroll init --!');
      },
    
      add(func) {
        scroll.functions.push(func);
        scroll.length = scroll.functions.length;
      },
    
      remove(func) {
        scroll.functions.splice(func, 1);
        scroll.length = scroll.functions.length;
      },
    
      update() {
        website.winHeight = window.innerHeight;
        website.scrollY   = window.pageYOffset;
    
        for ( let i = 0; i < scroll.length; i++ ) {
          let func = scroll.functions[i];
          func();
        }
    
        scroll.isRunning = false;
      },
    
    }
    
    
    const OrientationChange = {
    
      init() {
        window.addEventListener('orientationchange', function(e) {
          if ( !orientation.isRunning ) {
            orientation.isRunning = true;
    
            orientation.animationFrame = window.requestAnimationFrame( OrientationChange.update );
          }
        });
    
        console.log('!-- orientationchange init --!');
      },
    
      add(func) {
        orientation.functions.push(func);
        orientation.length = orientation.functions.length;
      },
    
      remove(func) {
        orientation.functions.splice(func, 1);
        orientation.length = orientation.functions.length;
      },
    
      update() {
        for ( let i = 0; i < orientation.length; i++ ) {
          let func = orientation.functions[i];
          func();
        }
    
        orientation.isRunning = false;
      },
    
    }
    

    const Modules = {
      init() {
        mod = {
          targetSmooth: 'js-scroll',
          smoothSpeed: 600,
    
          // targetTab: "js-tab",
    
          targetAccordion: 'js-accordion',
          targetAccordionSP: 'js-accordionSP',
    
          targetModalOpen: 'js-modal',
          targetModalClose: 'js-modalClose',
          targetModalOverlay: 'js-modalOverlay',
          actBodyModal: 'is-modal',
    
          // targetTmpClone: 'js-tmpClone',
    
          // targetLozad: '.js-lozad',
    
          // targetCursor: 'js-cursor',
          // targetCursorTag: '',
          // cursorMagnet: false,
          // cursorClass: website.act,
          // cursorOffClass: website.inact,
    
          // targetAlign     : 'js-align',
          // targetAlignList : [],
          // alignAddClass   : 'u-alignHeight',
    
          // masonryElms: document.getElementsByClassName('js-masonry'),
        };
    
        // if (document.getElementById(mod.targetCursor) != null) {
        //   mod.targetCursorTag = document.getElementById(mod.targetCursor);
        //   this.cursor();
        // }
    
        // let alignList = document.querySelectorAll('.' + mod.targetAlign);
        // mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
    
        this.viewportHeight();
        this.scrollbarWidth();
        this.iosCheck();
        this.deviceCheck();
        this.smoothScroll();
        this.dragScroll();
        this.tabBtn();
        this.accordionBtn();
        this.modalBtn();
        // this.tmpClone();
        // this.masonry();
      },
    
      viewportHeight() {
        let vh = website.winHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },
      scrollbarWidth() {
        let element = document.createElement('div');
        element.style.visibility = 'hidden';
        element.style.overflow = 'scroll';
        document.body.appendChild(element);
        let scrollbarWidth = element.offsetWidth - element.clientWidth;
        document.body.removeChild(element);
        document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
      },
    
      iosCheck() {
        if (
          website.ua.indexOf('ipad') > -1 ||
          website.ua.indexOf('iphone') > -1 ||
          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
        ) {
          $('body').addClass('is-ios');
        } else {
          $('body').removeClass('is-ios');
        }
      },
    
      deviceCheck() {
        if (
          website.ua.indexOf('iphone') > -1 ||
          website.ua.indexOf('ipod') > -1 ||
          (website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1)
        ) {
          website.isDesktop = false;
          website.isMobile = true;
          $('body').removeClass('is-pc is-tb').addClass('is-sp');
        } else if (
          website.ua.indexOf('ipad') > -1 ||
          website.ua.indexOf('Android') > -1 ||
          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
        ) {
          website.isDesktop = false;
          website.isMobile = false;
          $('body').removeClass('is-pc is-sp').addClass('is-tb');
        } else {
          website.isDesktop = true;
          website.isMobile = false;
          $('body').removeClass('is-tb is-sp').addClass('is-pc');
        }
      },
    
      smoothScroll() {
        $('.' + mod.targetSmooth + '[href^="#"]').on('click', function () {
          let href = $(this).attr('href');
          let target = $(href == '#' ? 'html' : href);
    
          if (target.length) {
            let shift =
              website.winWidth < website.shiftPoint && href != '#' ? website.headTag.offsetHeight : 0;
            let position = target.offset().top - shift;
    
            $('body,html').animate({ scrollTop: position }, mod.smoothSpeed, 'swing');
            return false;
          }
        });
      },
    
      dragScroll() {
        // スクロールのドラッグ有効化
        jQuery.prototype.mousedragscrollable = function () {
          let target;
          $(this).each(function (i, e) {
            $(e).mousedown(function (event) {
              event.preventDefault();
              target = $(e);
              $(e).data({
                down: true,
                move: false,
                x: event.clientX,
                y: event.clientY,
                scrollleft: $(e).scrollLeft(),
                scrolltop: $(e).scrollTop(),
              });
              return false;
            });
            $(e).click(function (event) {
              if ($(e).data('move')) {
                return false;
              }
            });
          });
          $(document)
            .mousemove(function (event) {
              if ($(target).data('down')) {
                event.preventDefault();
                let move_x = $(target).data('x') - event.clientX;
                let move_y = $(target).data('y') - event.clientY;
                if (move_x !== 0 || move_y !== 0) {
                  $(target).data('move', true);
                } else {
                  return;
                }
                $(target).scrollLeft($(target).data('scrollleft') + move_x);
                $(target).scrollTop($(target).data('scrolltop') + move_y);
                return false;
              }
            })
            .mouseup(function (event) {
              $(target).data('down', false);
              return false;
            });
        };
      },
    
      tabBtn() {
        $('.' + mod.targetTab).each(function () {
          let tabObj = $('> li > a', this),
            contId = $(this).data('tab') ? $(this).data('tab') : '',
            contObj = contId ? $(contId).children('div') : $(this).next().children('div');
    
          tabObj.on('click', function () {
            let tabHref = $(this).attr('href');
    
            tabObj.removeClass(website.act);
            $(this).addClass(website.act);
    
            contObj.hide();
            $(tabHref).fadeIn();
    
            return false;
          });
        });
      },
    
      accordionBtn() {
        $('.' + mod.targetAccordion).on('click', function () {
          if ($(this).hasClass(website.act)) {
            $(this).removeClass(website.act).next().stop().slideUp('fast');
            // $(this).removeClass(website.act);
          } else {
            $(this).addClass(website.act).next().stop().slideDown();
            // $(this).addClass(website.act);
          }
        });
    
        $('.' + mod.targetAccordionSP).on('click', function () {
          if (website.winWidth < website.shiftPoint) {
            if ($(this).hasClass(website.act)) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              // $(this).removeClass(website.act);
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
              // $(this).addClass(website.act);
            }
            return false;
          }
        });
      },
    
      modalBtn() {
        document.addEventListener('DOMContentLoaded', () => {
          const hash = window.location.hash;
          if (hash) {
            const link = document.querySelector(`a[href="${hash}"]`);
            if (link) {
              setTimeout(() => {
                link.click();
              }, 500);
            }
          }
        });
    
        $(document).on('click', '.' + mod.targetModalOpen, function (e) {
          let href;
          if ($(this).attr('href')) {
            href = $(this).attr('href');
          } else {
            href = $(this).data('modal');
          }
          $('html').addClass(mod.actBodyModal);
          $(href).addClass(website.actOpen).parent().addClass(website.act);
    
          if (typeof homeTheme !== 'undefined') {
            homeTheme.Components['Autoplay'].pause();
          }
          return false;
        });
    
        $('.' + mod.targetModalClose).each(function () {
          $(this).on('click', function () {
            $('.' + website.actOpen + ' iframe').each(function () {
              let playerWindow = $(this)[0].contentWindow;
              playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', '*');
            });
    
            $('html').removeClass(mod.actBodyModal);
            $(this)
              .closest('.' + website.actOpen)
              .removeClass(website.actOpen)
              .parent()
              .removeClass(website.act);
    
            if (typeof homeTheme !== 'undefined') {
              homeTheme.Components['Autoplay'].play();
            }
          });
        });
    
        $(document).on('click', '.' + mod.targetModalOverlay, function () {
          $('.' + website.actOpen + ' iframe').each(function () {
            let playerWindow = $(this)[0].contentWindow;
            playerWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', '*');
          });
    
          $('html').removeClass(mod.actBodyModal);
          $(this)
            .nextAll('.' + website.actOpen)
            .removeClass(website.actOpen)
            .parent()
            .removeClass(website.act);
    
          if (typeof homeTheme !== 'undefined') {
            homeTheme.Components['Autoplay'].play();
          }
        });
      },
    
      // tmpClone() {
      //   $('.' + mod.targetTmpClone).each(function () {
      //     let targetId = $(this).data('tmp'),
      //       loopNum = $(this).data('loop');
    
      //     for (var i = 0; i < loopNum; i++) {
      //       let clone = document.getElementById(targetId).content.cloneNode(true);
      //       this.appendChild(clone);
      //     }
      //   });
      // },
    
      // lozad() {
      //   const el = document.querySelectorAll(mod.targetLozad);
      //   const observer = lozad(el);
      //   observer.observe();
      // },
    
      // cursor() {
      //   document.addEventListener('mousemove', function (e) {
      //     if (!mod.cursorMagnet) {
      //       mod.targetCursorTag.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
      //     }
      //   });
    
      //   let linkElem = document.querySelectorAll('a, button, [data-cursor]');
      //   for (let i = 0; i < linkElem.length; i++) {
      //     linkElem[i].addEventListener('mouseover', function (e) {
      //       if (this.dataset.hover !== undefined) {
      //         mod.cursorClass = this.dataset.hover;
      //       } else {
      //         mod.cursorClass = website.act;
      //       }
      //       mod.targetCursorTag.classList.add(mod.cursorClass);
    
      //       if (this.dataset.magnet !== undefined) {
      //         mod.cursorMagnet = this.querySelector('.' + this.dataset.magnet);
      //       }
    
      //     });
      //     linkElem[i].addEventListener('mouseout', function (e) {
      //       mod.targetCursorTag.classList.remove(mod.cursorClass);
      //       mod.cursorMagnet = false;
      //     });
      //   }
    
      //   let linkOffElem = document.querySelectorAll('[data-cursor-off]');
      //   for (let i = 0; i < linkOffElem.length; i++) {
      //     linkOffElem[i].addEventListener('mouseover', function (e) {
      //       document.body.classList.add(mod.cursorOffClass);
      //     });
      //     linkOffElem[i].addEventListener('mouseout', function (e) {
      //       document.body.classList.remove(mod.cursorOffClass);
      //     });
      //   }
      // },
      // cursorMagnet() {
      //   let cursorMagnetClient = mod.cursorMagnet.getBoundingClientRect();
      //   mod.targetCursorTag.style.transform = 'translate(' + (cursorMagnetClient.left + cursorMagnetClient.width / 2) + 'px, ' + (cursorMagnetClient.top + cursorMagnetClient.height / 2) + 'px)';
      // },
    
      // alignHeight() {
      //   let alignHeight  = 0;
    
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = 'auto';
      //     target.classList.add(mod.alignAddClass);
      //     alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
      //     target.classList.remove(mod.alignAddClass);
      //   });
      //   mod.targetAlignList.forEach((target) => {
      //     target.style.minHeight = alignHeight + 'px';
      //   });
      // },
    
      masonry() {
        if (mod.masonryElms != null) {
          for (let i = 0; i < mod.masonryElms.length; i++) {
            const masonry = mod.masonryElms[0];
            const childElms = masonry.children;
            const rowHeight = parseInt(
              window.getComputedStyle(masonry).getPropertyValue('grid-auto-rows')
            );
    
            for (let i = 0; i < childElms.length; i++) {
              const rowSpan = Math.ceil(childElms[i].querySelector('*').clientHeight / rowHeight);
              childElms[i].style.gridRowEnd = 'span ' + rowSpan;
            }
          }
        }
      },
    };
    

    
    const Wordpress = {
    
      init() {
        wp = {
          editorTarget: 'js-editor',
          tableClass: 'c-tblResponsive',
          iframeclass: 'c-iframe',
        };
    
        this.wpEditor();
      },
    
      wpEditor() {
        if (document.getElementById(wp.editorTarget) != null) {
          $('#' + wp.editorTarget + ' table').each(function () {
            $(this).wrap('<div class="' + wp.tableClass + '"></div>');
          });
          $('#' + wp.editorTarget + ' iframe').each(function () {
            $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
          });
        }
        // if ( $('.' + wp.editorTarget).length ) {
        //   $( '.' + wp.editorTarget + ' table' ).each(function() {
        //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
        //   });
        //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
        //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        //   });
        // }
      }
    
    }
    
    

    const SplideSlider = {
      init() {
        // ランダムなスライド開始位置
        const slideCount = document.querySelectorAll('#js-splideHomeTheme .splide__slide').length;
        const randomStart = Math.floor(Math.random() * slideCount);
        let homeTheme;
    
        slider = {
          homeKvElm: document.getElementById('js-splideHomeKv'),
          homeKvOpt: {
            type: 'loop',
            perPage: 1,
            gap: 0,
            autoplay: true,
            interval: 9000,
            pagination: false,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
    
          homeAboutElm: document.getElementById('js-splideHomeAbout'),
          homeAboutOpt: {
            autoScroll: {
              speed: 0.25,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            autoWidth: true,
            // fixedWidth: "30rem",
            gap: '1rem',
            pagination: false,
            arrows: false,
            // breakpoints: {
            //   991.9: {
            //     // fixedWidth: "22rem",
            //     gap: '4rem',
            //   },
            //   767.9: {
            //     // fixedWidth: "15rem",
            //     gap: '2.5rem',
            //   },
            //   575.9: {
            //     gap: '1rem',
            //   },
            // },
          },
    
          homeAboutTopElm: document.getElementById('js-splideHomeAboutTop'),
          homeAboutTopOpt: {
            autoScroll: {
              speed: 0.5,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            autoWidth: true,
            // fixedWidth: "30rem",
            gap: '2rem',
            pagination: false,
            arrows: false,
            // breakpoints: {
            //   991.9: {
            //     // fixedWidth: "22rem",
            //     gap: "4rem",
            //   },
            //   767.9: {
            //     // fixedWidth: "15rem",
            //     gap: "2.5rem",
            //   },
            //   575.9: {},
            // },
          },
    
          homeAboutBtmElm: document.getElementById('js-splideHomeAboutBtm'),
          homeAboutBtmOpt: {
            autoScroll: {
              speed: '-0.5',
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            autoWidth: true,
            // fixedWidth: "30rem",
            gap: '2rem',
            pagination: false,
            arrows: false,
            // breakpoints: {
            //   991.9: {
            //     // fixedWidth: "22rem",
            //     gap: "4rem",
            //   },
            //   767.9: {
            //     // fixedWidth: "15rem",
            //     gap: "2.5rem",
            //   },
            //   575.9: {},
            // },
          },
    
          homePointElm: document.getElementById('js-splideHomePoint'),
          homePointOpt: {
            autoplay: true,
            perMove: 1,
            interval: 3000,
    
            autoScroll: {
              speed: 1000,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            autoWidth: true,
            // fixedWidth: "30rem",
            gap: '5rem',
            pagination: false,
            arrows: false,
            breakpoints: {
              991.9: {
                // fixedWidth: "22rem",
                gap: '5rem',
              },
              767.9: {
                // fixedWidth: "15rem",
                // gap: "2.5rem",
                padding: '2rem',
              },
              575.9: {
                gap: '4rem',
              },
            },
          },
    
          homeThemeElm: document.getElementById('js-splideHomeTheme'),
          homeThemeOpt: {
            focus: 'center',
            start: randomStart,
    
            autoplay: true,
            perMove: 1,
            interval: 3000,
    
            autoScroll: {
              speed: 1000,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            type: 'loop',
            autoWidth: true,
            // fixedWidth: "30rem",
            gap: '-5rem',
            pagination: false,
            arrows: false,
            updateOnMove: true,
            breakpoints: {
              991.9: {
                // fixedWidth: "22rem",
                // gap: '5rem',
              },
              767.9: {
                // fixedWidth: "15rem",
                // gap: "2.5rem",
                // padding: '2rem',
              },
              575.9: {
                gap: '0rem',
              },
            },
          },
        };
      },
    
      homeKv() {
        if (slider.homeKvElm != null) {
          const homeKv = new Splide(slider.homeKvElm, slider.homeKvOpt);
          homeKv.mount();
        }
      },
      homeAbout() {
        if (slider.homeAboutElm != null) {
          const homeAbout = new Splide(slider.homeAboutElm, slider.homeAboutOpt);
          homeAbout.mount(window.splide.Extensions);
        }
      },
      homeAboutTop() {
        if (slider.homeAboutTopElm != null) {
          const homeAboutTop = new Splide(slider.homeAboutTopElm, slider.homeAboutTopOpt);
          homeAboutTop.mount(window.splide.Extensions);
        }
      },
    
      homeAboutBtm() {
        if (slider.homeAboutBtmElm != null) {
          const homeAboutBtm = new Splide(slider.homeAboutBtmElm, slider.homeAboutBtmOpt);
          homeAboutBtm.mount(window.splide.Extensions);
        }
      },
    
      homePoint() {
        document.addEventListener('DOMContentLoaded', function () {
          if (slider.homePointElm != null) {
            const homePoint = new Splide(slider.homePointElm, slider.homePointOpt);
            document.querySelector('.p-homePointSlide-prev').addEventListener('click', () => {
              homePoint.go('<');
            });
            document.querySelector('.p-homePointSlide-next').addEventListener('click', () => {
              homePoint.go('>');
            });
            homePoint.mount();
          }
        });
      },
    
      homeTheme() {
        document.addEventListener('DOMContentLoaded', function () {
          if (slider.homeThemeElm != null) {
            homeTheme = new Splide(slider.homeThemeElm, slider.homeThemeOpt);
            document.querySelector('.p-homeThemeSlide-prev').addEventListener('click', () => {
              homeTheme.go('<');
            });
            document.querySelector('.p-homeThemeSlide-next').addEventListener('click', () => {
              homeTheme.go('>');
            });
    
            homeTheme.mount();
          }
        });
      },
    
      homeModal(num) {
        document.addEventListener('DOMContentLoaded', function () {
          const thumb = '.--gallery' + num + ' .splide-thumb';
          const thumb_options = {
            mediaQuery: 'min',
            gap: '0.2rem',
            perMove: 1,
            arrows: false,
            pagination: false,
            isNavigation: true,
            perPage: 3.5,
            updateOnMove: true,
            breakpoints: {
              992: {
                perPage: 6.5,
                gap: '1rem',
              },
            },
          };
          const thumbSplide = new Splide(thumb, thumb_options);
          const main = '.--gallery' + num + ' .splide-main';
          const main_options = {
            mediaQuery: 'min',
            type: 'fade',
            arrows: false,
            pagination: false,
            breakpoints: {
              600: {},
            },
          };
          const mainSplide = new Splide(main, main_options);
          document
            .querySelector('.--gallery' + num + ' .splide-main-prev')
            .addEventListener('click', () => {
              mainSplide.go('<');
            });
          document
            .querySelector('.--gallery' + num + ' .splide-main-next')
            .addEventListener('click', () => {
              mainSplide.go('>');
            });
          mainSplide.sync(thumbSplide);
          mainSplide.mount();
          thumbSplide.mount();
        });
      },
    };
    

    const Animation = {
      init() {
        anime = {
          // add: 'js-animeAdd',
    
          // time: website.page == "ferrytrip" || !Cookies.get("visited") ? 1900 : 0,
          time: 0,
    
          // word: 'js-animeWord',
        };
    
        // this.addAnime();
        // this.word();
      },
    
      // check() {
      //   $("." + website.targetAnime + ":not(." + website.actAnime + ")").each(
      //     function () {
      //       let self = $(this),
      //         targetPosition = self.offset().top,
      //         triggerPosition,
      //         shift;
    
      //       if (website.winWidth < website.shiftPoint) {
      //         shift = website.winHeight / website.shiftSp;
      //       } else {
      //         shift = website.winHeight / website.shiftPc;
      //       }
      //       triggerPosition = targetPosition - website.winHeight + shift;
    
      //       if (website.scrollY > triggerPosition) {
      //         if (typeof self.data("delay") !== "undefined") {
      //           self.css("transitionDelay", self.data("delay") + "ms");
      //         }
      //         self.addClass(website.actAnime);
      //       }
      //     }
      //   );
      // },
    
      // addAnime() {
      //   let targets = Array.prototype.slice.call(document.querySelectorAll('.' + anime.add), 0);
      //   targets.forEach((target) => {
      //     if (target.dataset.anime) {
      //       target.style.animation = target.dataset.anime;
      //     }
      //   });
      // },
    
      loader() {
        // if (website.page == "home") {
        //   // document.getElementById(anime.loader).classList.add(website.act);
    
        //   setTimeout(function () {
        //     document.scrollingElement.scrollTop = 0;
        //   }, 100);
        // } else if (location.hash != "" && location.hash != "#") {
        //   setTimeout(function () {
        //     let shift =
        //         website.winWidth < website.shiftPoint
        //           ? website.headTag.offsetHeight
        //           : 0,
        //       position = $(location.hash).offset().top - shift;
        //     $("body, html").animate(
        //       { scrollTop: position },
        //       mod.smoothSpeed,
        //       "swing"
        //     );
        //   }, 100);
        // }
    
        document.body.classList.add(website.loaded);
    
        if (!Cookies.get("visited")) {
          Cookies.set("visited", 1, { expires: 7, path: "/" });
        }
    
        setTimeout(function () {
          if (website.page == "ferrytrip") {
            // LpHomePage.init();
            LpHomePage.videoScale();
            LpHomePage.expoBg();
          }
    
          PageScroll.observerAnime();
        }, anime.time);
      },
    
      // word() {
      //   let wordList = document.querySelectorAll('.' + anime.word),
      //     targetsWord = Array.prototype.slice.call(wordList, 0),
      //     delayHead = 0;
    
      //   targetsWord.forEach((target) => {
      //     let text = target.innerHTML,
      //       html = '',
      //       delay = 200;
    
      //     if (target.dataset.delay) {
      //       delay = target.dataset.delay - 0;
      //     }
    
      //     text.split(' ').forEach(function (w) {
      //       if (w == '<br>') {
      //         html += w;
      //         delay -= 100;
      //       } else if (w == '&nbsp;') {
      //         html += w;
      //       } else {
      //         html += '<span><span style="transition-delay: ' + delay + 'ms;">' + w + '</span></span>';
      //       }
      //       delay += 50;
      //     });
      //     target.innerHTML = html;
      //   });
      // },
    };
    

    const PageScroll = {
      init() {
        scrollOption = {
          target: document.getElementById("js-inertiaFrame"),
          translateY: 0,
          contHeight: 0,
          velocity: 0.08,
    
          animeTargets: document.querySelectorAll(
            "." + website.targetAnime + ":not(." + website.actAnime + ")"
          ),
          animeOptions: {
            rootMargin: "-15% 0px",
            threshold: 0,
          },
    
          navDisplayFrame: document.getElementById("js-navDisplay"),
          navDisplayTargets: document.querySelectorAll(".js-navDisplayObserver"),
          navDisplayOptions: {
            rootMargin: "-50% 0px",
            threshold: 0,
          },
        };
    
        // this.observerAnime();
        // this.observerNavDisplay();
      },
    
      set() {
        scrollOption.contHeight =
          scrollOption.target.getBoundingClientRect().height - 1;
        document.body.style.height = Math.floor(scrollOption.contHeight) + "px";
      },
      smooth() {
        this.set();
    
        let diff = website.scrollY - scrollOption.translateY;
    
        if (diff !== 0) {
          if (Math.abs(diff) > 1) {
            scrollOption.translateY += diff * scrollOption.velocity;
          } else {
            scrollOption.translateY = website.scrollY;
          }
          scrollOption.target.style.transform =
            "translate3d(0, -" + scrollOption.translateY + "px, 0)";
        }
      },
    
      observerAnime() {
        let observer = new IntersectionObserver(
          this.observerCallbackAnime,
          scrollOption.animeOptions
        );
        scrollOption.animeTargets.forEach((target) => {
          if (target.dataset.delay) {
            target.style.transitionDelay = target.dataset.delay + "ms";
          }
          observer.observe(target);
        });
      },
      observerCallbackAnime(entries, object) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          let data = entry.target.dataset.splide;
          if (typeof data !== "undefined" && data === "about") {
            SplideSlider.homeAbout();
            SplideSlider.homeAboutTop();
            SplideSlider.homeAboutBtm();
            
          } else {
            entry.target.classList.add(website.actAnime);
          }
          object.unobserve(entry.target);
        });
      },
    
      observerNavDisplay() {
        let observer = new IntersectionObserver(
          this.observerCallbackNavDisplay,
          scrollOption.navDisplayOptions
        );
        scrollOption.navDisplayTargets.forEach((target) => {
          observer.observe(target);
        });
      },
      observerCallbackNavDisplay(entries, object) {
        entries.forEach(function (entry, i) {
          let data = entry.target.dataset.display;
          if (data !== "" && typeof data !== "undefined") {
            let displayClass = "is-" + data;
            if (entry.isIntersecting) {
              scrollOption.navDisplayFrame.classList.add(displayClass);
            } else {
              scrollOption.navDisplayFrame.classList.remove(displayClass);
            }
          }
        });
      },
    };
    

    // OFF

    // ./inc/_parallax.js

    const LpHomePage = {
      init() {
        home = {
          videoId: '#js-video',
          videoScaleId: '#js-videoScale',

          pointElms: document.querySelectorAll('.js-pointItem'),
          pointCloseElms: document.querySelectorAll('.js-pointClose'),

          expoOpt: {
            targetId: '#js-expoBg',
            items: [
              {
                moveId: '#js-expoMove01',
                bottomId: '#js-expoBottom01',
                translate: { pc: 0.1, tb: -0.03, sp: -0.03 },
                rotate: 160,
              },
              {
                moveId: '#js-expoMove02',
                bottomId: '#js-expoBottom02',
                translate: { pc: 0.3, tb: -0.02, sp: -0.02 },
                rotate: 185,
              },
              {
                moveId: '#js-expoMove03',
                bottomId: '#js-expoBottom03',
                translate: { pc: -0.03, tb: 0.06, sp: -0.06 },
                rotate: 210,
              },
              {
                moveId: '#js-expoMove04',
                bottomId: '#js-expoBottom04',
                translate: { pc: 0, tb: -0.08, sp: -0.08 },
                rotate: 190,
              },
            ],
          },

          pageHeight: document.documentElement.offsetHeight,
        };

        SplideSlider.homeKv();
        SplideSlider.homeAbout();
        SplideSlider.homeAboutTop();
        SplideSlider.homeAboutBtm();
        LpHomePage.pointDisplay();
        // LpHomePage.videoScale();
        // LpHomePage.expoBg();
        SplideSlider.homePoint();
        SplideSlider.homeTheme();
        for (let i = 1; i <= 7; i++) {
          let num = i.toString().padStart(2, '0');
          SplideSlider.homeModal(num);
        }
        LpHomePage.drawer();
        LpHomePage.accordionRoute();
        LpHomePage.accessTab();
        LpHomePage.hashAnker();
      },

      pointDisplay() {
        home.pointElms.forEach((elm) => {
          elm.addEventListener('touchstart', function (e) {
            e.stopPropagation();
            elm.parentElement.classList.add(website.act);
          });
        });
        home.pointCloseElms.forEach((elm) => {
          elm.addEventListener('touchstart', function (e) {
            e.stopPropagation();
            elm.parentElement.parentElement.parentElement.classList.remove(website.act);
          });
        });
      },

      videoScale() {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(home.videoScaleId, {
          ease: 'none',
          scale: 1,
          scrollTrigger: {
            trigger: home.videoId, // アニメーションが始まるトリガーとなる要素。
            start: 'top bottom', // アニメーションが始まる位置
            end: 'center center+=15%', // アニメーションが終わる位置
            // end: () => "bottom", // アニメーション開始位置から固定する距離
            pin: false, // トリガー要素を固定する
            scrub: 0.9, // スクロール量に応じてアニメーション
            invalidateOnRefresh: true, // リサイズ再計算？
            anticipatePin: 1, // 素早いスクロールに対するピン留め遅延回避
            // once: true,
            // markers: true,
          },
        });
      },

      expoBg() {
        gsap.registerPlugin(ScrollTrigger);
        const device = website.isDesktop ? 'pc' : website.isMobile ? 'sp' : 'tb';

        home.expoOpt.items.forEach((item) => {
          const moveElm = document.querySelector(item.moveId);
          const moveRect = moveElm.getBoundingClientRect();

          const bottomElm = document.querySelector(item.bottomId);
          const bottomRect = bottomElm.getBoundingClientRect();

          const shift = moveRect.width * item.translate[device];
          // console.log(shift);

          // console.log(moveRect.top);
          // console.log(bottomRect.top);

          // console.log(bottomRect.left - moveRect.left);

          gsap.to(item.moveId, {
            ease: 'none',
            x: () => {
              const moveElm = document.querySelector(item.moveId);
              const moveRect = moveElm.getBoundingClientRect();

              const bottomElm = document.querySelector(item.bottomId);
              const bottomRect = bottomElm.getBoundingClientRect();

              const shift = moveRect.width * item.translate[device];

              return bottomRect.left - moveRect.left + shift;
            },
            y: () => {
              const moveElm = document.querySelector(item.moveId);
              const moveRect = moveElm.getBoundingClientRect();

              const bottomElm = document.querySelector(item.bottomId);
              const bottomRect = bottomElm.getBoundingClientRect();

              return bottomRect.top - moveRect.top;
            },
            rotation: item.rotate,
            scrollTrigger: {
              trigger: home.expoOpt.targetId, // アニメーションが始まるトリガーとなる要素。
              start: () => 'top top', // アニメーションが始まる位置
              end: () => 'bottom bottom', // アニメーションが終わる位置
              // end: () => "bottom", // アニメーション開始位置から固定する距離
              pin: false, // トリガー要素を固定する
              scrub: 0.9, // スクロール量に応じてアニメーション
              invalidateOnRefresh: true, // リサイズ再計算？
              anticipatePin: 1, // 素早いスクロールに対するピン留め遅延回避
              // once: true,
              // markers: true,
            },
          });
        });
      },

      scrollTriggerRefresh() {
        const pageHeight = document.documentElement.offsetHeight;
        if (home.pageHeight !== pageHeight) {
          home.pageHeight = pageHeight;
          ScrollTrigger.refresh();
        }
      },

      drawer() {
        document.querySelector('.p-drawerBtn').addEventListener('click', function () {
          this.classList.toggle('is-show');
          document.querySelector('.p-drawer').classList.toggle('is-show');
          document.querySelector('.p-drawerLayer').classList.toggle('is-show');
          // document.body.style.overflow = (document.body.style.overflow === 'hidden') ? 'visible' : 'hidden';
          document.body.classList.toggle('is-modal');
        });

        document.querySelectorAll('.p-drawerMenu__list a').forEach(function (el) {
          el.addEventListener('click', function () {
            document.querySelector('.p-drawerBtn').classList.remove('is-show');
            document.querySelector('.p-drawer').classList.remove('is-show');
            document.querySelector('.p-drawerLayer').classList.remove('is-show');
            // document.body.style.overflow = 'visible';
            document.body.classList.remove('is-modal');
          });
        });
      },

      accordionRoute() {
        const accordionRouteToggles = document.querySelectorAll('.accordionRoute-toggle');
        // アコーディオン切り替え（SP用）
        accordionRouteToggles.forEach((accordionRouteToggle) => {
          accordionRouteToggle.addEventListener('click', () => {
            const accordionRoutepanel = accordionRouteToggle.closest('.accordionRoute-panel');
            // SPサイズのときのみ動作
            if (window.innerWidth <= 768) {
              accordionRoutepanel.classList.toggle('active');
            }
          });
        });
      },

      // accordion() {
      //   const accordions = document.querySelectorAll('.js-accordion');
      //   accordions.forEach((accordion) => {
      //     accordion.addEventListener('click', () => {
      //       const accordionContent = accordion.next();
      //       // accordionContent.classList.toggle('is-active');
      //     });
      //   });
      // },

      accessTab() {
        const tabs = document.querySelectorAll('.tab-button');
        const panels = document.querySelectorAll('.tab-panel');
        const toggles = document.querySelectorAll('.accordion-toggle');

        // タブ切り替え（PC用）
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const index = tab.dataset.index;

            tabs.forEach((t) => t.classList.remove('active'));
            tab.classList.add('active');

            panels.forEach((p) => p.classList.remove('active'));
            document.querySelector(`.tab-panel[data-index="${index}"]`).classList.add('active');
          });
        });

        // アコーディオン切り替え（SP用）
        toggles.forEach((toggle) => {
          toggle.addEventListener('click', () => {
            const panel = toggle.closest('.tab-panel');

            // SPサイズのときのみ動作
            if (window.innerWidth <= 768) {
              panel.classList.toggle('active');
            }
          });
        });

        // 初期状態設定（PCのみ最初の1つを開く）
        window.addEventListener('DOMContentLoaded', () => {
          if (window.innerWidth > 768) {
            tabs[0].classList.add('active');
            panels[0].classList.add('active');
          }
        });

        // リサイズ時補正（PCへ戻ったときに1つだけ開くように）
        window.addEventListener('resize', () => {
          if (window.innerWidth > 768) {
            let activeIndex = Array.from(panels).findIndex((p) => p.classList.contains('active'));
            if (activeIndex === -1) {
              tabs[0].classList.add('active');
              panels[0].classList.add('active');
            } else {
              tabs.forEach((t) => t.classList.remove('active'));
              tabs[activeIndex].classList.add('active');
            }
          }
        });
      },

      hashAnker() {
        const hash = window.location.hash;
        if (hash) {
          document.documentElement.style.overflow = 'hidden';
          document.documentElement.style.visibility = 'hidden';

          window.addEventListener('load', function () {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
              setTimeout(() => {
                document.documentElement.style.visibility = '';
                targetElement.scrollIntoView();
                document.documentElement.style.overflow = '';
              }, 1000);
            } else {
              document.documentElement.style.overflow = '';
              document.documentElement.style.visibility = '';
            }
          });
        }
      },

      update() {},
    };
    const LpRoutePage = {
      init() {
        route = {
          mapTargetId: 'js-routeMap',
        };

        LpRoutePage.mapSwitch();
      },

      mapScroll() {
        if (document.getElementById(route.mapTargetId) != null) {
          let target = document.getElementById(route.mapTargetId),
            targetChildren = target.children,
            imgWidth = targetChildren[0].clientWidth;

          target.scrollLeft = imgWidth * 0.59;

          $('#' + route.mapTargetId).mousedragscrollable();
        }
      },

      mapSwitch() {
        let $this = $('#' + route.mapTargetId),
          targetId = $this.data('target'),
          tabObj = $(targetId + '> li').children();

        tabObj.on('click', function () {
          let dataDisplay = $(this).data('display');

          tabObj.removeClass(website.act);
          $(this).addClass(website.act);
          $this.attr('data-map', dataDisplay);

          return false;
        });
      },

      update() {},
    };

    const CommonPage = {
      init() {
        common = {
          // pageTopTag: document.getElementById('js-pageTop'),
          // megaMenuTarget: 'js-megaMenu',
          // megaMenuFadeOut: 400,

          soundElm: document.getElementById('js-sound'),
          soundBtnElms: document.querySelectorAll('.js-soundBtn'),
          soundBtnSwitchElm: document.querySelector('.js-soundBtnSwitch'),
          soundWhistleElm: document.getElementById('js-soundWhistle'),
          soundWaveElm: document.getElementById('js-soundWave'),
        };

        // this.pageTop();
        // this.megaMenuView();
        // this.scrollUpView();
      },

      bgmOpe() {
        if (common.soundElm != null) {
          common.soundWhistleElm.volume = 0.2;
          common.soundWaveElm.volume = 0.3;

          common.soundBtnSwitchElm.classList.add(website.actView);

          // if (
          //   document.referrer.match(/ferrytrip\/route/) ||
          //   document.referrer.match(/ferrytrip\/news/)
          // ) {
          //   common.soundElm.classList.add(website.inact);
          // }

          // if (Cookies.get("sound")) {
          //   common.soundElm.classList.add(website.actClose);
          //   common.soundBtnSwitchElm.classList.add(website.actView);

          //   // if (Cookies.get("sound") === "on") {
          //   //   common.soundBtnSwitchElm.classList.add(website.actView);
          //   //   common.soundWhistleElm.play();
          //   //   common.soundWaveElm.play();
          //   // }
          // }

          // common.soundBtnElms.forEach((btn) => {
          //   btn.addEventListener("click", (e) => {
          //     let data = btn.getAttribute("data-sound");
          //     if (data === "on") {
          //       common.soundWhistleElm.play();
          //       common.soundWaveElm.play();
          //       common.soundBtnSwitchElm.classList.add(website.act);
          //       Cookies.set("sound", "on", { expires: 7 });
          //     } else {
          //       common.soundWaveElm.pause();
          //       common.soundBtnSwitchElm.classList.remove(website.act);
          //       Cookies.set("sound", "off", { expires: 7 });
          //     }
          //     common.soundBtnSwitchElm.classList.add(website.actView);
          //     common.soundElm.classList.add(website.actClose);
          //   });
          // });

          common.soundBtnSwitchElm.addEventListener('click', (e) => {
            const hasClass = e.target.classList.contains(website.act);
            if (hasClass) {
              common.soundWaveElm.pause();
              common.soundWaveElm.pause();
              common.soundBtnSwitchElm.classList.remove(website.act);
              Cookies.set('sound', 'off', { expires: 7 });
            } else {
              common.soundWhistleElm.currentTime = 0;
              common.soundWaveElm.currentTime = 0;
              common.soundWhistleElm.play();
              common.soundWaveElm.play();
              common.soundBtnSwitchElm.classList.add(website.act);
              Cookies.set('sound', 'on', { expires: 7 });
            }
          });
        }
      },

      // pageTop() {
      //   if (basic.pageTopTag != null) {
      //     if (website.scrollY <= 100) {
      //       basic.pageTopTag.classList.remove(website.actView);
      //     } else {
      //       basic.pageTopTag.classList.add(website.actView);
      //     }
      //   }
      // },

      // megaMenuView() {
      //   let nodeList = document.querySelectorAll('.' + basic.megaMenuTarget),
      //     timer = {};

      //   nodeList.forEach((target, index) => {
      //     timer[index] = null;

      //     if (website.isDesktop) {
      //       target.addEventListener(`mouseenter`, () => {
      //         clearTimeout(timer[index]);
      //         target.classList.add(website.actView);
      //       });
      //       target.addEventListener(`mouseleave`, () => {
      //         timer[index] = setTimeout(function () { target.classList.remove(website.actView); }, basic.megaMenuFadeOut);
      //       });
      //     } else {
      //       let megamenuNode = target.querySelector('[data-megamenu]');

      //       target.addEventListener(`click`, function (e) {
      //         if (target.classList.contains(website.actView) === true) {
      //           target.classList.remove(website.actView);
      //         } else {
      //           target.classList.add(website.actView);
      //         }
      //       });
      //       megamenuNode.addEventListener(`click`, function (e) {
      //         e.stopPropagation();
      //       });
      //       document.addEventListener('click', (e) => {
      //         if (!e.target.closest('.' + basic.megaMenuTarget)) {
      //           target.classList.remove(website.actView);
      //         }
      //       });
      //     }

      //   });
      // },

      // scrollUpView() {
      //   if (website.scrollY === website.scrollCurrent) {
      //     return;
      //   }

      //   if (website.scrollY <= 10 || website.scrollY < website.scrollCurrent) {
      //     website.headTag.classList.add(website.actView);
      //   } else {
      //     website.headTag.classList.remove(website.actView);
      //   }

      //   website.scrollCurrent = website.scrollY;
      // },

      update() {},
    };

    const App = {
      init() {
        this.set();
      },

      set() {
        Modules.init();
        Animation.init();
        PageScroll.init();
        // Parallax.init();
        Wordpress.init();
        SplideSlider.init();
        CommonPage.init();

        if (website.page == 'ferrytrip') {
          LpHomePage.init();
        } else if (website.page == 'route') {
          LpRoutePage.init();
          WinLoad.add(LpRoutePage.mapScroll);
        }

        WinLoad.add(Animation.loader);
        WinLoad.add(CommonPage.bgmOpe);

        WinResize.add(Modules.iosCheck);
        WinResize.add(Modules.deviceCheck);

        WinResizeWidth.add(Modules.viewportHeight);
        WinResizeWidth.add(Modules.scrollbarWidth);
        // WinResizeWidth.add( Modules.alignHeight );

        WinScroll.add(LpHomePage.scrollTriggerRefresh);
        // WinScroll.add(BasicPage.scrollUpView);

        // OrientationChange.add( xxx );

        WinLoad.init();
        WinResize.init();
        WinResizeWidth.init();
        WinScroll.init();
        OrientationChange.init();
      },

      update() {
        // website.animationFrame = window.requestAnimationFrame(App.update);
        // website.winWidth = window.innerWidth;
        // website.winHeight = window.innerHeight;
        // website.scrollY = window.pageYOffset;
        // if (website.isDesktop) {
        //   PageScroll.smooth();
        //   if (mod.cursorMagnet) {
        //     Modules.cursorMagnet();
        //   }
        //   if (website.page == 'home') {
        //     Parallax.deviateScroll();
        //   }
        // }
      },
    };

    App.init();
  })();
})(jQuery);
